import { render, staticRenderFns } from "./NominaQwince.vue?vue&type=template&id=0b2a5ea2&"
import script from "./NominaQwince.vue?vue&type=script&lang=js&"
export * from "./NominaQwince.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports